module.exports = __webpack_public_path__ + "static/media/chart_45.09cd81e7.png";